module.exports = __webpack_public_path__ + "img/caselist33.07a0467d.jpg";